import { uploadService } from './../../../../shared/uploadService';
import { Component, OnInit, Pipe } from '@angular/core';
import { AchievementsService } from '../../services/achievements-services';
import { Achievements } from '../../models/achievement';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { FileVm } from '../../../../shared/Models/fileVm';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-acheivement',
  templateUrl: './add-acheivement.component.html',
  styleUrls: ['./add-acheivement.component.scss'],
})
export class AddAcheivementComponent implements OnInit {
  model = {} as Achievements;
  attachements = new FormData();
  isEdit = false;
  constructor(
    private route : Router,
    private diagRef: NbDialogRef<AddAcheivementComponent>,
    private service: AchievementsService,
    private uploadService: uploadService,
    private toast: NbToastrService
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    if (this.isEdit) {
      this.uploadService.updateFiles({ files: [], previousAttachments: this.model.attachements });
    }
    if (!this.isEdit) {
      this.model.contentAR = '';
      this.model.contentEN = '';
      this.uploadService.updateFiles({ files: [], previousAttachments: [] });
    }
  }

  save() {
    // let fileInput = document.getElementById('attachements') as any;
    // let hasEntries = false;
    // this.attachements.forEach(() => {
    //   hasEntries = true;
    // });
    // if (hasEntries) {
    //   this.service.uploadMultipleFiles(this.attachements).subscribe((res) => {
    //     this.model.attachements = [];
    //     res.forEach((element) => {
    //       this.model.attachements.push({
    //         fileName: element,
    //       } as FileVm);
    //     });

    //     this.saveAchievement();
    //   });
    // } else {
    //   this.saveAchievement();
    // }

    this.uploadService
      .uploadMultipleFiles()
      .pipe(
        switchMap((res) => {
          this.model.attachements = res;
          return this.isEdit ? this.service.put(this.model.id, this.model) : this.service.post(this.model);
        })
      )
      .subscribe(
        (res) => {
          this.diagRef.close('true');
          this.isEdit
            ? this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 })
            : this.toast.show('تم الإضافة بنجاح', '', { status: 'success', duration: 3000 });
        },
        (err) => {
          this.diagRef.close('true');
          this.isEdit
            ? this.toast.danger('خطأ في التعديل', '', { status: 'success', duration: 3000 })
            : this.toast.danger('خطأ في الحفظ', '', { status: 'success', duration: 3000 });
        }
      );
  }

  close() {
    this.diagRef.close();
  }

  isFormValid() {
    return this.model.nameAR;
  }
}
